import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'booking-summary-mobile',
    templateUrl: './booking-summary-mobile.component.html',
    styleUrls: ['./booking-summary-mobile.component.scss']
})
export class BookingSummaryMobileComponent implements OnInit {

    @Input() booking: any;
    @Output() emitActions: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    getColoredBookingStatus(status: any) {
        switch (status) {
            case 'Arrived':
                return 'tertiary-bgcolor';
            case 'In Progress':
                return 'in-progress';
            case 'Delivered':
                return 'delivered';
            case 'Planned':
                return 'planned';
            case 'Confirmed':
                return 'confirmed';
            case 'Booking Created':
                return 'booking-created';
            case 'Completed':
                return 'planned';
            case 'Customs Cleared':
                return 'in-progress';
            case 'Stuffed':
                return 'tertiary-bgcolor';
            case 'Carted':
                return 'tertiary-bgcolor';
            case 'Departed':
                return 'delivered';
            case 'Sailed':
                return 'planned';
            case 'Document Received':
                return 'confirmed';
            case 'Truck Placed':
                return 'tertiary-bgcolor';
            case 'Truck Dispatched':
                return 'in-progress';
            case 'Initiated':
                return 'planned';
            case 'Cancelled':
                return 'p-text-danger';
        }
    }

    applyColorTextBaseOnType(shipmentBookingType: any) {
        switch (shipmentBookingType) {
            case 'AIR':
                return 'AIR';
            case 'LCL':
                return 'LCL';
            case 'FCL':
                return 'p-text-success';
            case 'Transport':
                return 'p-text-warning';
            case 'Service Job':
                return 'service-job ';
            case 'Clearance':
                return 'custom-clearance';
            case 'Custom Clearance':
                return 'custom-clearance';
        }
    }

    handleClickActions(actionFrom: any, booking: any) {
        this.emitActions
            .emit({
                actionFrom,
                booking
            });
    }
}
